export default {
  loanAmount: {
    default: 5000,
    min: 1000,
    max: 1000000,
    info: [{ copy: 'This is loan amount' }]
  },
  termInYears: {
    default: 5,
    min: 0.083,
    max: 40,
    maxLength: 2,
    callback: 'setTermInYears',
    info: [{ copy: 'This is term in years' }]
  },
  termInMonths: {
    default: 60,
    min: 1,
    max: 480,
    maxLength: 3,
    callback: 'setTermInMonths',
    info: [{ copy: 'This is term in months' }]
  },
  interestRate: {
    default: 4.5,
    min: 0.001,
    max: 99,
    info: [{ copy: 'This is interest rate per year' }]
  },
  startDate: {
    default: new Date(),
    info: [{ copy: 'This is start date' }]
  },
  yearlyExtraPaymentMonth: {
    callback: 'setMonth'
  },
  oneTimeExtraPaymentMonth: {
    callback: 'setOneTimeExtraPaymentMonth'
  },
  oneTimeExtraPaymentYear: {
    callback: 'setOneTimeExtraPaymentYear'
  },
  products: [{ id: 216 }]
}
